module.exports = __webpack_public_path__ + "img/brand-click-gestao.6eb77e4a.svg";